import { ArrowUpRight, ShoppingBag, CalendarCheck2 } from "lucide-react";
import { Link } from "react-router-dom";
import { BOUTIQUE_ENABLED } from "@/lib/features";

export default function HeroSection() {
  return (
    <section
      id="accueil"
      className="relative bg-[#00224D] text-pearl pt-32 pb-32 grain overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1644088379091-d574269d422f?auto=format&fit=crop&w=1800&q=80')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#00224D]/80 via-[#00224D]/70 to-[#00224D]" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 border border-pearl/20 reveal" data-testid="hero-badge">
          <span className="dot dot-neuro" />
          <span className="font-mono-overline text-pearl/70">
            Cabinet de conseil indépendant — interventions dans le monde entier
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 mt-12 items-start">
          <div className="lg:col-span-7">
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight reveal reveal-d1" data-testid="hero-headline">
              Ton organisation te consume.
              <br />
              <em className="text-pearl/70 not-italic font-light">Reprends le contrôle.</em>
            </h1>

            <p className="mt-8 text-pearl/75 text-lg leading-relaxed max-w-2xl reveal reveal-d2" data-testid="hero-subhead">
              ShinRai accompagne les dirigeants qui veulent sortir du mode pompier. Une seule méthode, trois
              disciplines : Lean management, neurosciences appliquées et IA
              opérationnelle. Pour bâtir une organisation qui se pilote — et qui
              tient dans le temps.
            </p>

            <div className="mt-10 flex flex-wrap gap-4 reveal reveal-d3">
              <a href="#diagnostic" className="btn-white" data-testid="hero-cta-diagnostic">
                Diagnostic gratuit · 45 min <ArrowUpRight size={16} />
              </a>
              {BOUTIQUE_ENABLED && (
                <Link to="/boutique" className="btn-outline-white" data-testid="hero-cta-boutique">
                  <ShoppingBag size={16} /> Voir la boutique
                </Link>
              )}
            </div>
          </div>

          <div className="lg:col-span-5 lg:mt-6 reveal reveal-d4">
            <div className="bg-pearl/5 backdrop-blur-md border border-pearl/15 p-8">
              <div className="font-mono-overline text-pearl/45 mb-6">
                Résultats agrégés — missions ShinRai
              </div>
              <div className="grid grid-cols-3 gap-4 mb-8">
                <div data-testid="hero-stat-waste">
                  <div className="font-serif text-4xl text-pearl">−30<span className="text-2xl align-top">%</span></div>
                  <div className="text-xs text-pearl/60 mt-1">délais d'exécution</div>
                </div>
                <div data-testid="hero-stat-adoption">
                  <div className="font-serif text-4xl text-pearl">92<span className="text-2xl align-top">%</span></div>
                  <div className="text-xs text-pearl/60 mt-1">adhésion équipes</div>
                </div>
                <div data-testid="hero-stat-roi">
                  <div className="font-serif text-4xl text-pearl">&lt;6<span className="text-lg align-top ml-1">mois</span></div>
                  <div className="text-xs text-pearl/60 mt-1">premier ROI mesuré</div>
                </div>
              </div>

              <div className="editorial-divider mb-6">
                <span className="font-mono-overline text-pearl/40">trois piliers</span>
              </div>

              <ul className="space-y-3 text-sm">
                <li className="flex items-start gap-3">
                  <span className="dot dot-lean mt-1.5" />
                  <span><strong className="text-pearl">Lean.</strong> <span className="text-pearl/65">Éliminer le gaspillage, fluidifier la valeur.</span></span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="dot dot-neuro mt-1.5" />
                  <span><strong className="text-pearl">Neurosciences.</strong> <span className="text-pearl/65">Ancrer le changement dans les têtes.</span></span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="dot dot-ia mt-1.5" />
                  <span><strong className="text-pearl">IA opérationnelle.</strong> <span className="text-pearl/65">Automatiser ce qui peut l'être.</span></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
